import React from "react";

const leftCylinderImg = require("../../../assets/left-cylinder-part.png");
const middleCylinderImg = require("../../../assets/middle-cylinder-part.png");
const rightCylinderImg = require("../../../assets/right-cylinder-part.png");
const buttonCylinderImg = require("../../../assets/cylinder-button.png");

const Cylinder = ({ dimensionA, dimensionB, isButtonCylinder }) =>
	<div className="cylinder">
		{/* Left part */}
		<div className="cylinder__left">
			<img src={leftCylinderImg} />
			<span style={{width: `${dimensionA}px`}} className="cylinder__extender" />
		</div>

		{/* Middle part */}
		<img src={middleCylinderImg} />

		{/* Right part */}
		<div className="cylinder__right">
			<span style={{width: `${dimensionB}px`}} className="cylinder__extender" />
			{
				isButtonCylinder
					? <img src={buttonCylinderImg} />
					: <img src={rightCylinderImg} />
			}
		</div>
	</div>

export default Cylinder;



// WEBPACK FOOTER //
// ./src/js/plan/lockings/Cylinder.js